import Phaser from 'phaser';
import { CONFIG } from '../config.js';
import { Enemy } from '../entities/Enemy.js';
import { Boss } from '../entities/Boss.js';
import { Pickup } from '../entities/Pickup.js';
import { generateQuestion } from '../data/verbs.js';

export class SpawnSystem {
  constructor(scene) {
    this.scene = scene;
  }

  buildQuestion() {
    const pool = this.scene.getVerbPool ? this.scene.getVerbPool() : null;
    const mode = this.scene.askMode || 'random';
    return generateQuestion(pool, mode);
  }

  randomEdgePosition() {
    const W = CONFIG.GAME_WIDTH;
    const top = CONFIG.PLAY_AREA_TOP;
    const bottom = CONFIG.PLAY_AREA_BOTTOM;
    const margin = 36;
    const side = Phaser.Math.Between(0, 3);
    if (side === 0) return { x: Phaser.Math.Between(20, W - 20), y: top - margin / 2 + 8 };
    if (side === 1) return { x: Phaser.Math.Between(20, W - 20), y: bottom - 8 };
    if (side === 2) return { x: 12, y: Phaser.Math.Between(top + 12, bottom - 12) };
    return { x: W - 12, y: Phaser.Math.Between(top + 12, bottom - 12) };
  }

  spawnEnemy(type, opts = {}) {
    const pos = opts.position || this.randomEdgePosition();
    const enemy = new Enemy(this.scene, pos.x, pos.y, type, opts);
    enemy.setQuestion(this.buildQuestion());
    this.scene.enemies.add(enemy);
    const finalScale = enemy.scaleX;
    enemy.setScale(0.1);
    this.scene.tweens.add({
      targets: enemy,
      scale: finalScale,
      duration: 220,
      ease: 'Back.easeOut',
    });
    return enemy;
  }

  spawnMinion(x, y) {
    const enemy = new Enemy(this.scene, x, y, 'slime', {
      isMinion: true,
      hp: CONFIG.BOSS_MINION_HP,
      speed: 70,
      damage: 10,
      scaleOverride: CONFIG.ENEMY_DISPLAY_SCALE * 0.85,
    });
    enemy.setQuestion(this.buildQuestion());
    this.scene.enemies.add(enemy);
    const finalScale = enemy.scaleX;
    enemy.setScale(0.1);
    this.scene.tweens.add({
      targets: enemy,
      scale: finalScale,
      duration: 220,
      ease: 'Back.easeOut',
    });
    return enemy;
  }

  spawnBoss() {
    const x = CONFIG.GAME_WIDTH / 2;
    const y = CONFIG.PLAY_AREA_TOP + 60;
    const bossConfig = (CONFIG.BOSSES && CONFIG.BOSSES[this.scene.level]) || CONFIG.BOSSES.basic;
    const boss = new Boss(this.scene, x, y, bossConfig);
    boss.setQuestion(this.buildQuestion());
    this.scene.enemies.add(boss);
    const finalScale = boss.scaleX;
    boss.setScale(0.1);
    this.scene.tweens.add({ targets: boss, scale: finalScale, duration: 600, ease: 'Back.easeOut' });
    return boss;
  }

  trySpawnPickup(x, y) {
    if (Math.random() >= CONFIG.DROP_CHANCE) return null;
    const type = this.pickWeightedDrop();
    const pickup = new Pickup(this.scene, x, y, type);
    this.scene.pickups.add(pickup);
    return pickup;
  }

  pickWeightedDrop() {
    const weights = CONFIG.DROP_WEIGHTS;
    const total = Object.values(weights).reduce((a, b) => a + b, 0);
    let roll = Math.random() * total;
    for (const [type, w] of Object.entries(weights)) {
      roll -= w;
      if (roll <= 0) return type;
    }
    return 'gem';
  }
}
